import api from "@/lib/api";

let _countries = null;
let _languages = null;
let _countriesPromise = null;
let _languagesPromise = null;

export async function loadCountries() {
  if (_countries) return _countries;
  if (!_countriesPromise) {
    _countriesPromise = api.get("/meta/countries").then((r) => {
      _countries = r.data;
      return _countries;
    });
  }
  return _countriesPromise;
}

export async function loadLanguages() {
  if (_languages) return _languages;
  if (!_languagesPromise) {
    _languagesPromise = api.get("/meta/languages").then((r) => {
      _languages = r.data;
      return _languages;
    });
  }
  return _languagesPromise;
}

export function countryName(code, list) {
  if (!code) return "";
  const item = (list?.items || []).find((c) => c.code === code);
  return item ? item.name : code;
}

export function languageName(code, list) {
  if (!code) return "";
  const item = (list?.items || []).find((l) => l.code === code);
  return item ? item.name : code;
}
